import React from 'react';
import { css } from 'react-emotion';
import { FlexColumn } from 'appStyles';
import {
  withRedux,
  validateUrl
} from 'helpers';

const container = css`
  justify-content: center;
  position: relative;
  height: 100%;

  img {
    width: 5rem;
    margin-bottom: 5rem;
  }

  a {
    cursor: pointer;
    text-decoration: none;
    color: white !important;
  }
`;

const validUrl = (url) => {
  var pattern = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)?/gi;
  return pattern.test(url) ? true : false;
};

const alertUrl = (url) => {
  if(!validUrl(url)) alert('Please enter a valid URL. ex. https://google.com');
};

const Website = props => {
  const { activeTemplate } = props;
  const component = activeTemplate.components[0];
  const { url } = component.view;

  return (
    <div className={container}>
      {
        url && 
        <FlexColumn height='93%'>
          <a href={validateUrl(url)} target='_blank'><img src={`//logo.clearbit.com/${url}`} /></a>
          <a href={validateUrl(url)} target='_blank'>{url}</a>
        </FlexColumn>
      }
      {/* TODO: give credit to clear bit when deploy to production */}
    </div>
  );
};

export default withRedux(Website);
